module.exports = __webpack_public_path__ + "img/aeroland-digital-store-image-02.fa79f1d3.png";